import { createEnvelopeSource } from './create-envelope-source';

/**
 * Profile-creation conversion source. Pure config over the standardized envelope
 * (`GET /analytics/profile-creation`): `registrations` / `installs` are scalar
 * counts, `conversionRate` is the install -> registration ratio. All
 * mapping/fetching lives in `createEnvelopeSource`. The rate is meaningful at the
 * Couche-Tard (Quebec) / Circle K (ROC) / national level and is suppressed for a
 * partial-ROC region selection (backend alignment rule). The line form requests
 * daily granularity and renders the per-day registrations series served by the
 * backend; the series carries registrations only (the app stores expose no
 * per-day install volume, so there is no daily rate).
 */
export const profileCreationConversionSource = createEnvelopeSource({
    label: 'Profile creation conversion',
    endpoint: 'analytics/profile-creation',
    metrics: [
        { id: 'registrations', label: 'Profile creations', type: 'scalar' },
        { id: 'installs', label: 'Installs', type: 'scalar' },
        {
            id: 'conversionRate',
            label: 'Install to registration rate',
            type: 'ratio',
        },
    ],
    forms: ['number', 'rate', 'line'],
    regionGrain: 'brand',
});
